import { createAction, handleActions } from 'redux-actions';
import { getFirstError } from '@adjust/dashboard-core/lib/errorMessage/errorMessage';

const initialState = {
  isChangingEmail: false,
  isAlertOpen: false,
  trace: {
    status: 'info',
    message: '',
  },
};

// Actions

export const EMAIL_CHANGE_STARTED = 'userDetails/userEmail/EMAIL_CHANGE_STARTED';
export const EMAIL_CHANGE_SUCCEEDED = 'userDetails/userEmail/EMAIL_CHANGE_SUCCEEDED';
export const EMAIL_CHANGE_FAILED = 'userDetails/userEmail/EMAIL_CHANGE_FAILED';
export const ALERT_CLOSE = 'userDetails/userEmail/ALERT_CLOSE';
export const EMAIL_RESEND = 'userDetails/userEmail/EMAIL_RESEND';

// Action creators

export const changeEmail = createAction(EMAIL_CHANGE_STARTED);
export const changeEmailFailed = createAction(EMAIL_CHANGE_FAILED);
export const changeEmailSucceeded = createAction(EMAIL_CHANGE_SUCCEEDED);
export const closeAlert = createAction(ALERT_CLOSE);
export const resendEmail = createAction(EMAIL_RESEND);

// Reducer

const handleChangeStarted = state => ({
  ...state,
  isChangingEmail: true,
});

const handleChangeFailed = (state, { payload }) => ({
  ...state,
  isChangingEmail: false,
  isAlertOpen: true,
  trace: {
    status: 'error',
    message: getFirstError(payload.password, {
      invalid: t('error.invalid_password'),
    }),
  },
});

const handleChangeSucceeded = (state, { payload }) => ({
  ...state,
  isChangingEmail: false,
  isAlertOpen: true,
  trace: {
    status: 'info',
    message: payload ? t('user.email_change.success_message') : t('user.email_change.success_message-admin'),
  },
});

const handleStatusClose = state => ({
  ...state,
  isAlertOpen: false,
});

const handleResend = state => ({
  ...state,
  isChangingEmail: true,
});

export default handleActions(
  {
    [EMAIL_CHANGE_STARTED]: handleChangeStarted,
    [EMAIL_CHANGE_FAILED]: handleChangeFailed,
    [EMAIL_CHANGE_SUCCEEDED]: handleChangeSucceeded,
    [ALERT_CLOSE]: handleStatusClose,
    [EMAIL_RESEND]: handleResend,
  },
  initialState,
);

// Selectors

export const getEditUserEmailDetails = state => state.userDetails.userEmail;
